<template>
    <div>
        <div class="page-wrapper">
            <div class="page-header d-print-none">
                <div class="container-xl">
                    <div class="row g-2 align-items-center">
                        <div class="col">
                            <div class="page-pretitle">
                                Usted se encuentra aquí:
                            </div>
                            <h2 class="page-title">
                                Licencia de Uso de la Información Pública - Decreto 4064 - Ley Nro. 5282/2014
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-body">
                <div class="container-xl">
                    <!-- <div class="row g-2 align-items-center">
                        <div class="col">
                            <h2 class="text-center">
                                Licencia de Uso de la Información Pública - Decreto 4064 - Ley Nro. 5282/2014
                            </h2>
                        </div>
                    </div>
                    <br> -->
                    <div class="row row-cards">
                        <div class="col-lg-12">
                            <div class="card card-lg">
                                <!-- <div class="card-header">
                                    <div class="markdown">
                                        <h2 class="text-center">Licencia de Uso de la Información Pública - Decreto 4064 - Ley Nro. 5282/2014</h2>
                                    </div>
                                </div> -->
                                <div class="card-body">
                                    <div class="markdown">
                                        <!-- <h2>Licencia de Uso de la Información Pública - Decreto 4064 - Ley Nro. 5282/2014</h2>
                                        <hr> -->
                                        <h2>Licencia de Uso de la Información y los Datos Abiertos Públicos propiedad del Estado Paraguayo</h2>
                                        <p :align="'justify'">Esta licencia otorga la autorización gratuita, perpetua y no exclusiva de uso y/o transformación de la información y los datos abiertos públicos propiedad del Estado Paraguayo a cualquier persona física o jurídica que haga uso de los mismos. Para efectos de la presente licencia, se entiende por uso y/o transformación autorizada de la información o los datos públicos, las actividades tales como: copia, extracción, reproducción, distribución, comunicación pública, adaptación, transformación y todo aquel uso lícito en cualquier modalidad y bajo cualquier formato, por el plazo máximo permitido por la Ley.</p>
                                        <h2>Condiciones de uso y/o transformación de la información o los datos</h2>

                                        <p :align="'justify'">La licencia de uso estará vigente siempre que el usuario cumpla con las siguientes condiciones:
                                            <ul>
                                                <li>Citar a la fuente pública que proveyó la información o los datos objeto del uso y/o transformación; y que el contenido se rige por la presente licencia.</li>
                                                <li>Citar la fecha de la última actualización de la información o los datos objeto del uso y/o transformación, siempre y cuando esto fuera conocido.</li>
                                                <li>No usar la información pública ni los datos abiertos públicos de forma que sugiera o simule un uso oficial o patrocinado por el Estado Paraguayo.</li>
                                            </ul>
                                        </p>
                                        <h2>Exclusión de responsabilidad</h2>
                                        <p :align="'justify'">El uso y/o transformación de la información pública o los datos lo realiza el usuario, bajo su exclusiva responsabilidad y riesgo.</p>
                                        <p :align="'justify'">En ningún caso la fuente pública proveedora de la información o los datos será responsable del uso que el usuario haga de la misma, ni tampoco de ningún daño económico o de cualquier índole que, en forma directa o indirecta, se derive u ocurra a terceros sobre sus bienes, equipos, actividad comercial, datos y aplicaciones, como consecuencia de dicho uso y/o transformación de los datos.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'Licencia',
    data() {
        return {
            content: '',
        };
    }
};


</script>